<template lang="pug">
.documents
  b-form-row.align-items-center.mt-3.mb-4
    b-col.mb-2.mb-md-0
      h4.mb-0 Documentos
    b-col(cols="auto")
      b-button.mr-2(variant="an", @click="uploadFileModal = true", :disabled="loading || busy") Crear documento
  b-row.h-100.overflow-y
    b-col.h-100.overflow-md-y.scrollable-area.br-1.p-0(md="4")
      b-overlay(:show="busy", variant="transparent", spinner-variant="primary")
        empty-message(v-if="!documents.length && !busy", message="No hay documentos creados")
        b-card(v-if="documents.length")
          b-nav(vertical, tabs)
            b-nav-item.mb-3(v-for="document in documents", :key="document.id", link-classes="account-link", :to="{name: 'document', params: { documentId: document.id } }") {{document.name}}
    b-col.h-100.overflow-y.scrollable-area
      empty-message(v-if="!$route.params.documentId  && !busy", :message="documents.length ? 'Selecciona un documento' : 'No hay documentos creados'")
      router-view(:key="$route.path", @destroy="openFirst")
  b-modal(v-model="uploadFileModal",
    centered
    header-class="b-0 pb-0",
    footer-class="b-0",
    cancel-title="Cancelar",
    ok-variant="an"
    ok-title="Crear documento",
    :ok-disabled="uploading || !documentFile",
    @ok="createDocument",
    @hidden="documentFile = null"
  )
    b-form-group.h-100#document-file-input
      b-file.h-100(placeholder="Selecciona un archivo", drop-placeholder="Suelta el archivo aquí", v-model="documentFile", :disabled="uploading", accept=".xlsx,.doc,.pdf")
        template(#placeholder)
          .text-center
            upload-icon.icon-xl
            .text-secondary.text-sm Subir archivo
        template(v-slot:file-name="{ names }")
          .text-center
            b-spinner(v-if="uploading", variant="primary")
            file-icon.icon-xl(v-else)
            .text-secondary.text-sm {{names[0]}}
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import {UploadFile} from '@/helpers/upload-file'

const documentsController = createNamespacedHelpers('document')

export default {
  name: 'Documents',
  data () {
    return {
      loading: false,
      busy: false,
      uploading: false,
      uploadFileModal: false,
      documentFile: null,
    }
  },
  computed: {
    ...documentsController.mapState({
      documents: state => state.documents
    })
  },
  methods: {
    ...mapActions([
      'document/all',
      'document/create',
      'helpers/upload_file'
    ]),
    getDocuments () {
      this.busy = true

      this['document/all']({
        accountId: this.$route.params.account_id,
        params: { type: 'file' },
        callback: res => {
          this.busy = false
          if (res.error) return this.$message.error(res.error)
          this.openFirst()
        }
      })
    },
    async createDocument (bvModalEvt) {
      bvModalEvt.preventDefault()
      this.uploading = true

      const name = this.documentFile.name.split('.').shift()
      const type = this.documentFile.name.split('.').pop()
      const { account_id: accountId } = this.$route.params
      const link = await this.getFileUrl()

      this['document/create']({
        accountId,
        link,
        name,
        type,
        callback: res => {
          this.uploading = this.uploadFileModal = false
          if (res.error) return this.$message.error(res.error)
          this.$router.push({name: 'document', params: { documentId: res.resource } }).catch(() => {})
        }
      })
    },
    openFirst() {
      if(this.documents.length && !this.$route.params.documentId) {
        this.$router.push({name: 'document', params: { documentId: this.documents[0].id } }).catch(() => {})
      }
    },
    getFileUrl() {
      return new Promise(async resolve => {
        const error = 'Error subiendo archivo'
        try {
          const url = await UploadFile.call(this, this.documentFile)
          if(!url) {
            this.$message.error(error)
            return resolve(false)
          }
          return resolve (url)
        } catch (e) {
          console.log(e)
          this.$message.error(error)
          return resolve(false)
        }
      })
    }
  },
  mounted () {
    this.getDocuments()
  },
}
</script>

<style lang="scss">
  .account-link {
    border-radius: 5px;

    &:hover, &.router-link-exact-active {
      background: rgba(14, 92, 207, 0.1) !important;
    }
  }

  #document-file-input {
    .custom-file-label {
      border-style: dashed;
      height: auto;
      margin: 0;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
      position: relative;
    }
    .custom-file-input{
      position: absolute;
    }
  }

  .custom-file-label:after {
    display: none !important;
  }
</style>